
const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']

const carreras = [
    {
        id: 1,
        nom_carrera: 'Ingeniería en Agricultura Sustentable y Protegida'
    },
    {
        id: 2,
        nom_carrera: 'Licenciatura en Enfermería'
    },
    {
        id: 3,
        nom_carrera: 'Licenciatura en Gastronomía'
    },
    {
        id: 4,
        nom_carrera: 'Ingeniería en Mantenimiento Industrial'
    },
    {
        id: 5,
        nom_carrera: 'Ingeniería en Mecatrónica'
    },
    {
        id: 6,
        nom_carrera: 'Ingeniería en Procesos Bioalimentarios'
    },
    {
        id: 7,
        nom_carrera: 'Ingeniería en Desarrollo y Gestión de Software'
    },
    {
        id: 8,
        nom_carrera: 'Licenciatura en Gestión y Desarrollo Turístico'
    },
    {
        id: 11,
        nom_carrera: 'Licenciatura en Contaduría'
    },
    {
        id: 12,
        nom_carrera: 'Maestría en Gestión e Innovación en las Organizaciones'
    },
    {
        id: 13,
        nom_carrera: 'Maestría en Agricultura Sustentable y de Precisión'
    },
    {
        id: 14,
        nom_carrera: 'Maestría en Desarrollo y Gestión Organizacional'
    },{
        id: 15,
        nom_carrera: 'Maestría en Ciencias en Agricultura Sostenible y de Precisión'
    },

]

const extencionImagen = [ 'jpg', 'jpeg', 'gif', 'png', 'svg' ]

const sortDirections = ['ascend', 'descend']

// const alias_examen = {
//     "Expresión Oral y Escrita": "EOYE",
//     "Matemáticas Ciencias": "MC",
//     "Matemáticas": "M",
//     "Inglés": "I"
// }

const alias_examen = {
    1: "EOYE",
    2: "MC",
    3: "MEA",
    4: "I",
    5: "MI",
}

const sin_editar = [ 'rectoria@utescuinapa.edu.mx' ]

const indice_reportes = [
    {
        id: 'respuestas_correctas_por_materia',
        titulo: 'Respuestas correctas por materia'
    },
    {
        id: 'cantidad_de_aspirantes_por_carrera',
        titulo: 'Cantidad de aspirantes por carrera'
    },
    {
        id: 'expedientes_reportes_individuales_enviados_por_correo_aspirantes',
        titulo: 'Expedientes de reportes individuales enviados por correo a aspirantes'
    },
    {
        id: 'aspirantes_participantes_en_aplicacion',
        titulo: 'Aspirantes que participaron por aplicación'
    },
    {
        id: 'enviar_correo_aspirante',
        titulo: 'Enviar correo a aspirantes'
    },
    {
        id: 'aspirantes_con_exámenes_pendientes',
        titulo: 'Aspirantes con exámenes pendientes'
    },
    {
        id: 'estado_de_aspirantes_en_cada_examen',
        titulo: 'Estado de aspirantes en cada examen'
    },
    {
        id: 'resultados_por_carrera',
        titulo: 'Resultados por carrera'
    },
    {
        id: 'resultados_agrupando_matemáticas',
        titulo: 'Resultados agrupando matemáticas'
    },
    {
        id: 'promedios_resultados_aspirantes',
        titulo: 'Promedios de resultados de aspirantes'
    },
    {
        id: 'promedios_resultados_aspirantes_ingles',
        titulo: 'Promedios de resultados de aspirantes en Inglés'
    },
    {
        id: 'respuestas_correctas_por_aspirante',
        titulo: 'Respuestas correctas por aspirante (Licenciatura)'
    },
    {
        id: 'respuestas_correctas_por_aspirante_maestria',
        titulo: 'Respuestas correctas por aspirante (Maestría)'
    },
]

const filters_carreras = [
    {
        text: 'Ingeniería en Agricultura Sustentable y Protegida',
        value: 'Ingeniería en Agricultura Sustentable y Protegida'
    },
    {
        text: 'Licenciatura en Enfermería',
        value: 'Licenciatura en Enfermería'
    },
    {
        text: 'Licenciatura en Gastronomía',
        value: 'Licenciatura en Gastronomía'
    },
    {
        text: 'Ingeniería en Mantenimiento Industrial',
        value: 'Ingeniería en Mantenimiento Industrial'
    },
    {
        text: 'Ingeniería en Mecatrónica',
        value: 'Ingeniería en Mecatrónica'
    },
    {
        text: 'Ingeniería en Procesos Bioalimentarios',
        value: 'Ingeniería en Procesos Bioalimentarios'
    },
    {
        text: 'Ingeniería en Desarrollo y Gestión de Software',
        value: 'Ingeniería en Desarrollo y Gestión de Software'
    },
    {
        text: 'Licenciatura en Gestión y Desarrollo Turístico',
        value: 'Licenciatura en Gestión y Desarrollo Turístico'
    },
    {
        text: 'Licenciatura en Contaduría',
        value: 'Licenciatura en Contaduría'
    },
    {
        text: 'Maestría en Gestión e Innovación en las Organizaciones',
        value: 'Maestría en Gestión e Innovación en las Organizaciones'
    },
    {
        text: 'Maestría en Desarrollo y Gestión Organizacional',
        value: 'Maestría en Desarrollo y Gestión Organizacional'
    },
    {
        text: 'Maestría en Ciencias en Agricultura Sostenible y de Precisión',
        value: 'Maestría en Ciencias en Agricultura Sostenible y de Precisión'
    },
]

export {
    dias,
    carreras,
    extencionImagen,
    sortDirections,
    alias_examen,
    sin_editar,
    indice_reportes,
    filters_carreras
}
